import React from 'react'
import { useStyles } from './ConfigurationStyle'
import threeline from '../../../assets/icons/servTopics/threeLines.svg'
import { Grid } from '@material-ui/core'
import info from '../../../assets/icons/servTopics/grayInfo.svg'
import downArrow from '../../../assets/icons/servTopics/downArrow2.svg'
export default function Configuration() {
    const style = useStyles()
    return (
        <div>
            <div className={style.configTopicName}>Topic name</div>
            <Grid container>
                <Grid xl={6} lg={6} md={6} sm={3} xs={3}>
                    <div>
                        <button className={style.linesButton}>
                            <img src={threeline} alt="lines" />
                        </button>
                    </div>
                </Grid>
                <Grid xl={6} lg={6} md={6} sm={3} xs={3}>
                    <div className={style.threeButtonAlign}>
                        <button className={style.threeButton}>Messages</button>
                        <button className={style.threeButton}>Modify</button>
                        <button className={style.threeButton0}>Remove</button>
                    </div>
                </Grid>
            </Grid>
            <div className={style.topicConfigtxt}>
                Topic configuration
            </div>
            <div className={style.topicConfigSubDiv}>
                <Grid container>
                    <Grid xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div>
                            <div className={style.topicConfigSubDivtxt}>Partitions</div>
                            <button className={style.topicConfigSubDivbutton}>1</button>
                        </div>
                    </Grid>
                    <Grid xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div style={{ float: "right" }}>
                            <div className={style.topicConfigSubDivtxt}>Repartition</div>
                            <button className={style.topicConfigSubDivbutton}>2</button>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div className={style.brokerTxt}>
                Broker configuration
            </div>
            <div className={style.brokerDiv}>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div className={style.topicConfigSubDivtxt}>
                            cleanup_policy
                        </div>
                        <div className={style.infoIcon}><img src={info} alt="info" /></div>
                    </div>
                    <input placeholder='delete' className={style.input} />
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div className={style.topicConfigSubDivtxt}>
                            message_format_version
                        </div>
                        <div className={style.infoIcon}><img src={info} alt="info" /></div>
                    </div>
                    <input placeholder='3.0-IV1' className={style.input2} />
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div className={style.topicConfigSubDivtxt}>
                            segment_bytes
                        </div>
                        <div className={style.infoIcon}><img src={info} alt="info" /></div>
                    </div>
                    <input placeholder='209715200' className={style.input2} />
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div className={style.topicConfigSubDivtxt}>
                            unclean_leader_election_enable
                        </div>
                        <div className={style.infoIcon}><img src={info} alt="info" /></div>
                    </div>
                    <input placeholder='false' className={style.input3} />
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div className={style.Kafkatxt}>
                    Kafka defaukt configuration
                </div>
                <div style={{ display: "flex", alignItems: "center" }}><img src={downArrow} alt="downArrow" /></div>
            </div>
            <div className={style.kafkaDiv}>
                {/* 1 */}
                <div className={style.kafkaSubDiv}>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                compression_type
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='poducer' className={style.Kafkainput} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                delete_retention_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='865240000' className={style.Kafkainput2} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                file_delete_delay_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='60000' className={style.Kafkainput3} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                flush_messages
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='9522222222222145' className={style.Kafkainput4} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                flush_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='9522222222222145' className={style.Kafkainput5} />
                    </div>
                </div>
                {/* 2 */}
                <div className={style.kafkaSubDiv} style={{ marginTop: "60px" }}>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                index_interval_bytes
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='4096' className={style.Kafkainput} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                max_compaction_lag_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='86524000040000' className={style.Kafkainput2} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                max_message_bytes
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='60150000' className={style.Kafkainput3} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                message_downconversion_enable
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='true' className={style.Kafkainput4} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                message_timestamp_difference_max_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='false' className={style.Kafkainput5} />
                    </div>
                </div>
                {/* 3 */}
                <div className={style.kafkaSubDiv} style={{ marginTop: "60px" }}>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                message_timestamp_type
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='Createtime' className={style.Kafkainput} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                min_cleanable_dirty_ratio
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='0.5' className={style.Kafkainput2} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                min_compaction_lag_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='0' className={style.Kafkainput3} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                min_insync_replicas
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='1' className={style.Kafkainput4} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                preallocate
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='false' className={style.Kafkainput5} />
                    </div>
                </div>
                {/* 4 */}
                <div className={style.kafkaSubDiv} style={{ marginTop: "60px" }}>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                retention_bytes
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='-1' className={style.Kafkainput} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                retention_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='5600009555' className={style.Kafkainput2} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                segment_index_bytes
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='568522221' className={style.Kafkainput3} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                segment_jitter_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='0' className={style.Kafkainput4} />
                    </div>
                    <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div className={style.topicConfigSubDivtxt}>
                                segment_ms
                            </div>
                            <div className={style.infoIcon}><img src={info} alt="info" /></div>
                        </div>
                        <input placeholder='5406825465215' className={style.Kafkainput5} />
                    </div>
                </div>
            </div>
        </div>
    )
}
